import { Link } from "react-router-dom";
import "./Item.css";

const Item = (props) => {
    const handleItemClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Adds smooth scrolling animation
        });
    }
    return (
        <div className="item">
            <Link to={`/product/${props.id}`}><img onClick={handleItemClick}  src={props.image} alt="" /></Link>
                <p>{props.name}</p>
                <div className="item-prices">
                    <div className="item-price-new">
                        <p>{props.new_price} ETB</p>
                    </div>
                    <div className="item-price-old">
                        <p>{props.old_price} ETB</p>
                    </div>
                </div>
        </div>
    );
}

export default Item;